import { ActivatedRoute } from '@angular/router';

/**
 * Given an activated route, return the most specific leaf node from its child-tree.
 *
 * @param {ActivatedRoute} route - An activated route
 * @return {ActivatedRoute} - The most specific activated route
 */
export function getMostSpecificActivatedRoute(route: ActivatedRoute) {
  return !route.firstChild
    ? route
    : getMostSpecificActivatedRoute(route.firstChild);
}

/**
 * Returns a identifier, ensuring that the trailing string `.html` is stripped, when present.
 *
 * @param {string} identifierPart - The candidate identifier, which may end `.html`
 * @returns {string} - The identifier, without `.html`
 */
export function idWithoutDotHtml(identifierPart: string): string {
  if (!identifierPart) {
    return identifierPart;
  }

  const matchParts = identifierPart.match(/^(.*).html$/);
  return matchParts && matchParts.length > 1 ? matchParts[1] : identifierPart;
}
